'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuGroupHeaderClassNames: function() {
        return menuGroupHeaderClassNames;
    },
    useMenuGroupHeaderStyles_unstable: function() {
        return useMenuGroupHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuGroupHeaderClassNames = {
    root: 'fui-MenuGroupHeader'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Be2twd7: "fy9rknc",
        sj55zd: "f11d4kpn",
        uwmqm3: [
            "f177v4lu",
            "f19lj068"
        ],
        z189sj: [
            "f19lj068",
            "f177v4lu"
        ],
        Bhrd7zp: "fl43uef",
        Bqenvij: "f1d2rq10",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59"
    }
}, {
    d: [
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".f11d4kpn{color:var(--colorNeutralForeground3);}",
        ".f177v4lu{padding-left:8px;}",
        ".f19lj068{padding-right:8px;}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".f1d2rq10{height:32px;}",
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}"
    ]
});
const useMenuGroupHeaderStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuGroupHeaderClassNames.root, styles.root, state.root.className);
    return state;
};
